<template>
  <ProSpaceRightPanel
    v-if="ids.length > 0"
    :header="header"
    :has-error="hasError"
    :loading="loading"
  >
    <template v-if="ids.length === 1" v-slot:center>
      <ProSpacePanelBlock :header="headerRoles">
        <ProSpacePanelBlockList :list="content" />
      </ProSpacePanelBlock>
    </template>
    <template v-if="ids.length === 1" v-slot:bottom>
      <ProSpacePanelBlock :header="headerBottom">
        <template v-slot>
          <ProSpacePanelBlockList :list="contentBottom" />
        </template>
      </ProSpacePanelBlock>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceAction,
  ProSpacePanelBlockHeader,
} from "@prospace/prospace-components-library";
import { mapGetters } from "vuex";

export default {
  name: "NotificationRolePanel",
  components: {
    ProSpaceRightPanel,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceAction,
    ProSpacePanelBlockHeader,
  },
  props: {
    service: {
      type: Object,
      required: true,
    },
    ids: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      role: null,
      header: {},
      loading: false,
      hasError: false,
      headerRoles: {
        title: this.$t("role"),
        isExpand: false,
      },
      headerBottom: {
        title: this.$t("metaInfTxt"),
        isExpand: true,
      },
    };
  },
  computed: {
    ...mapGetters({
      getFormatDateTime: "userinfoStore/getFormatDateTime",
    }),
    header() {
      if (this.role) {
        return {
          title: this.role.systemName,
          id: this.ids[0],
          status: this.getStatus(this.role.status),
          showCounter: false,
        };
      }
      return {
        title: this.$t("itemsSelected"),
        counter: this.ids.length,
        showCounter: true,
      };
    },
    content() {
      if (this.role) {
        return [
          [
            {
              title: this.$t("name"),
              text: this.role.systemName,
            },
          ],
        ];
      }
      return [];
    },
    contentBottom() {
      if (this.role) {
        return [
          [
            {
              title: this.$t("createdByTxt"),
              text: this.role.createdBy,
            },
            {
              title: this.$t("updatedByTxt"),
              text: this.role.updatedBy,
            },
          ],
          [
            {
              title: this.$t("createdAtTxt"),
              text: this.getFormatDateTime(this.role.createdAt)
            },
            {
              title: this.$t("lastUpdatedTxt"),
              text: this.getFormatDateTime(this.role.lastUpdated)
            },
          ],
        ];
      }
      return [];
    },
  },
  mounted() {
    this.update();
  },
  watch: {
    ids() {
      this.update();
    },
  },
  methods: {
    async update() {
      this.hasError = false;
      try {
        this.role = await this.getRole();
      } catch (e) {
        this.hasError = true;
      }
    },
    async getRole() {
      if (this.ids.length === 1) {
        this.loading = true;
        const res = await this.service.get(this.ids[0]);
        this.loading = false;
        return res.data;
      }
      return null;
    },
    getStatus(status) {
      if (!status) return;
      return {
        type: status === "ACTIVE" ? "success" : "danger",
        text: status[0].toUpperCase() + status.toLowerCase().slice(1),
      };
    },
  },
};
</script>
